export default __webpack_public_path__ + "static/media/Leggings of the Silent Slayer.ef4fe291.jpg";